export const formFields = {
  firstName: 'first_name',
  lastName: 'last_name',
  email: 'email',
  password: 'password',
  passwordConfirmation: 'password_confirmation',
}
